<template>
  <div class="sidebar" v-if="hasFrontendAccess">
    <ul>
      <li>
        <i class="cs-locations active"></i>
        <router-link to="/">{{ lang.map }}</router-link>
      </li>
      <li>
        <i class="cs-leaseagreement"></i>
        <a @click="onRouterClick('contracts')">{{ i18n.app.common.rent_contracts }}</a>
        <!-- <router-link to="/contracts">{{ i18n.app.common.rent_contracts }}</router-link> -->
      </li>
      <li>
        <i class="cs-car"></i>
        <a @click="onRouterClick('vehicles')">{{ i18n.app.common.vehicles }}</a>
        <!-- <router-link to="/contracts">{{ i18n.app.common.rent_contracts }}</router-link> -->
      </li>
      <li v-if="isAdmin">
        <i class="cs-leaseagreement"></i>
        <router-link to="/users">{{ lang.users }}</router-link>
      </li>
      <!-- <li><i class="cs-depot"></i><router-link to="/depots">Depot</router-link></li> -->
      <!-- 				<li><i class="cs-accounts"></i><router-link to="">Accounts</router-link></li> -->
      <!-- <li>
        <i class="cs-news"></i>
        <router-link to="/news">{{ lang.news }}</router-link>
      </li> -->
      <!-- 				<li><i class="cs-profiles"></i><router-link to="">Profielen</router-link></li> -->
      <!-- <li>
        <i class="cs-statistics"></i>
        <router-link to="/depots/statistics">{{ lang.stats }}</router-link>
      </li> -->
    </ul>
  </div>
</template>

<script>
import routeMixin from "@/mixins/route.mixin";
import { mapGetters } from "vuex";

const Sidebar = {
  name: "sidebar",
  data() {
    return {
      isAdmin: this.$store.getters.isAdmin,
      lang: i18n.app.components.sidebar,
    };
  },
  mixins: [routeMixin],
  methods: {
    onRouterClick(name) {
      const location = { name: name, query: this._loadQuery(name) };
      if (
        this.$router.resolve(location).route.fullPath === this.$route.fullPath
      ) {
        return;
      }
      this.$router.push(location);
    },
    getQuery() {
      sessionStorage;
    },
  },
  computed: {
    ...mapGetters({
      hasFrontendAccess: "hasFrontendAccess"
    })
  }
};

export default Sidebar;
</script>
